import { render, staticRenderFns } from "./CookCouture.vue?vue&type=template&id=251f91c0"
import script from "./CookCouture.vue?vue&type=script&lang=js"
export * from "./CookCouture.vue?vue&type=script&lang=js"
import style0 from "./CookCouture.vue?vue&type=style&index=0&id=251f91c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports